import { Box, Grid, styled } from "@mui/material";

import CopyToClipboard from "components/CopyToClipboard";
import ItemInformation from "./ItemInformation";
import { useSelector } from "react-redux";

export function InformationUsers() {
  const profile = useSelector((state) => state.user?.user?.data);

  return (
    <BoxInformation>
      <Grid container flexDirection="row-reverse">
        <Grid xs={12}>
          <ItemInformation
            tooltip={<CopyToClipboard value={profile?.code} />}
            information={profile?.code}
            title={"کد کاربری"}
            color={"secondary.main"}
          />

          <ItemInformation
            information={profile?.referralUserCode}
            title={"کاربر معرف "}
          />

          <ItemInformation
            information={profile?.date}
            title={"تاریخ ثبت نام "}
          />

          <ItemInformation
            information={profile?.group}
            title={"گروه کاربری "}
          />
        </Grid>
      </Grid>
    </BoxInformation>
  );
}

const BoxInformation = styled(Box)(({ theme }) => ({
  background: theme.palette.background.primaryGradient,
  borderRadius: "8px",
  border: `1px solid ${theme.palette.modules.border}`,
  padding: theme.spacing(2),
}));

export default InformationUsers;
